import { computed, type ComputedRef, onBeforeUnmount, onMounted, shallowRef } from "vue";
import dayjs, { type Dayjs } from "dayjs";
import { SECOND_IN_MILLISECONDS } from "@/constants/time";

const now = shallowRef<Dayjs>(dayjs());
let subscribersCount = 0;
let intervalId: ReturnType<typeof setInterval> | null = null;

function startTicking() {
  now.value = dayjs();
  intervalId = setInterval(() => {
    now.value = dayjs();
  }, SECOND_IN_MILLISECONDS);
}

function stopTicking() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

export function useNow(): { now: ComputedRef<Dayjs> } {
  onMounted(() => {
    subscribersCount++;

    if (!intervalId) {
      startTicking();
    }
  });

  onBeforeUnmount(() => {
    subscribersCount--;

    if (subscribersCount === 0) {
      stopTicking();
    }
  });

  return {
    now: computed<Dayjs>(() => now.value),
  };
}
